import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/Efemerides.css'; // Actualizar la ruta de importación

const efemeridesPorMes = [
    {
        mes: 'Septiembre',
        eventos: [
            '1 de septiembre: Inicio del mes patrio y entrega del Informe de Gobierno del Presidente de la República.',
            '4 de septiembre: Fundación de la Ciudad de México (Tenochtitlán) en 1521.',
            '8 de septiembre: Día Internacional de la Alfabetización.',
            '8 de septiembre: Natalicio de Josefa Ortiz de Domínguez (1768).',
            '11 de septiembre: Fallecimiento de Vicente Guerrero (1831).',
            '13 de septiembre: Gesta Heroica de los Niños Héroes de Chapultepec (1847).',
            '14 de septiembre: Incorporación de Chiapas a México (1824).',
            '15 de septiembre: Grito de Independencia.',
            '16 de septiembre: Inicio de la Guerra de Independencia (1810).',
            '19 de septiembre: Aniversario de los sismos de 1985 y 2017 en México.',
            '20 de septiembre: Fallecimiento de Manuel Tolsá (1816), arquitecto y escultor.',
            '23 de septiembre: Fundación de la Liga Comunista 23 de Septiembre (1973).',
            '27 de septiembre: Consumación de la Independencia de México (1821).',
            '28 de septiembre: Fundación del Primer Imperio Mexicano (1821).',
            '30 de septiembre: Natalicio de José María Morelos y Pavón (1765).',
        ],
    },
    {
        mes: 'Octubre',
        eventos: [
            '1 de octubre: Transmisión del poder presidencial en México (cada seis años).',
            '2 de octubre: Conmemoración de la Matanza de Tlatelolco (1968).',
            '4 de octubre: Fundación de San Francisco de Campeche (1540).',
            '7 de octubre: Natalicio de Francisco I. Madero (1873).',
            '12 de octubre: Día de la Raza.',
            '15 de octubre: Fundación de Monterrey (1596).',
            '19 de octubre: Día Mundial del Cáncer de Mama.',
            '22 de octubre: Día Mundial de la Medicina Tradicional.',
            '23 de octubre: Natalicio de Ignacio Zaragoza (1829).',
            '24 de octubre: Día de las Naciones Unidas.',
            '30 de octubre: Fundación de la Real y Pontificia Universidad de México (1551).',
        ],
    },
    {
        mes: 'Noviembre',
        eventos: [
            '1 de noviembre: Día de Todos los Santos.',
            '2 de noviembre: Día de Muertos.',
            '7 de noviembre: Fundación de la Villa de Colima (1523).',
            '14 de noviembre: Día Mundial de la Diabetes.',
            '16 de noviembre: Fundación de la Universidad Nacional Autónoma de México (UNAM) en 1910.',
            '18 de noviembre: Aniversario del levantamiento en armas de los hermanos Serdán en Puebla (1910).',
            '20 de noviembre: Aniversario de la Revolución Mexicana (1910).',
            '22 de noviembre: Día del Músico (Santa Cecilia).',
            '23 de noviembre: Día de la Armada de México.',
            '30 de noviembre: Fallecimiento de Sir Winston Churchill (1953).',
        ],
    },
    {
        mes: 'Diciembre',
        eventos: [
            '2 de diciembre: Creación de la Secretaría de la Defensa Nacional (1937).',
            '7 de diciembre: Día Internacional de la Aviación Civil.',
            '9 de diciembre: Fundación de la Ciudad de México por Hernán Cortés (1531).',
            '12 de diciembre: Día de la Virgen de Guadalupe.',
            '15 de diciembre: Inicio de sesiones del Congreso de la Unión (cada año).',
            '18 de diciembre: Día Internacional del Migrante.',
            '24 de diciembre: Nochebuena.',
            '25 de diciembre: Navidad.',
            '28 de diciembre: Día de los Santos Inocentes.',
            '31 de diciembre: Fin de Año.',
        ],
    },
    {
        mes: 'Enero',
        eventos: [
            '1 de enero: Año Nuevo.',
            '6 de enero: Día de Reyes.',
            '7 de enero: Matanza de Cananea (1906).',
            '13 de enero: Fundación de la Real Audiencia de la Nueva España (1528).',
            '21 de enero: Natalicio de Ignacio Allende (1769).',
            '24 de enero: Día Internacional de la Educación.',
            '25 de enero: Natalicio de Manuel Acuña, poeta romántico mexicano (1849).',
            '30 de enero: Día Escolar de la No Violencia y la Paz.',
            '31 de enero: Muerte de Juan Escutia en la defensa del Castillo de Chapultepec (1847).',
        ],
    },
    {
        mes: 'Febrero',
        eventos: [
            '2 de febrero: Día de la Candelaria.',
            '5 de febrero: Promulgación de la Constitución de 1917.',
            '9 de febrero: Aniversario de la Decena Trágica (1913).',
            '14 de febrero: Día del Amor y la Amistad.',
            '15 de febrero: Día Internacional del Cáncer Infantil.',
            '19 de febrero: Día del Ejército Mexicano.',
            '22 de febrero: Fallecimiento de Francisco I. Madero (1913).',
            '23 de febrero: Batalla de Río San Gabriel (1847).',
            '24 de febrero: Día de la Bandera.',
            '27 de febrero: Nacimiento del poeta mexicano Manuel Acuña (1849).',
        ],
    },
    {
        mes: 'Marzo',
        eventos: [
            '1 de marzo: Fundación de la Villa Rica de la Vera Cruz (1519).',
            '8 de marzo: Día Internacional de la Mujer.',
            '10 de marzo: Tratado de Guadalupe Hidalgo (1848).',
            '13 de marzo: Fundación de la Universidad Autónoma de Puebla (1937).',
            '18 de marzo: Expropiación Petrolera (1938).',
            '21 de marzo: Natalicio de Benito Juárez (1806).',
            '22 de marzo: Día Mundial del Agua.',
            '28 de marzo: Fundación de Torreón, Coahuila (1893).',
            '30 de marzo: Día Mundial del Trastorno Bipolar.',
        ],
    },
    {
        mes: 'Abril',
        eventos: [
            '7 de abril: Día Mundial de la Salud.',
            '10 de abril: Aniversario luctuoso de Emiliano Zapata (1919).',
            '13 de abril: Fundación de la Real Hacienda de Taxco (1529).',
            '15 de abril: Natalicio de Leonardo Bravo, insurgente mexicano (1764).',
            '18 de abril: Día Internacional de los Monumentos y Sitios.',
            '22 de abril: Aniversario de la Batalla de la Victoria (1847).',
            '23 de abril: Día Internacional del Libro.',
            '24 de abril: Fundación de la Villa de San Luis Potosí (1592).',
            '30 de abril: Día del Niño.',
        ],
    },
    {
        mes: 'Mayo',
        eventos: [
            '1 de mayo: Día Internacional del Trabajo.',
            '3 de mayo: Día de la Santa Cruz y de los trabajadores de la construcción.',
            '5 de mayo: Aniversario de la Batalla de Puebla (1862).',
            '7 de mayo: Fundación del Instituto Politécnico Nacional (1936).',
            '8 de mayo: Natalicio de Miguel Hidalgo y Costilla (1753).',
            '10 de mayo: Día de las Madres.',
            '15 de mayo: Día del Maestro.',
            '17 de mayo: Día Mundial de las Telecomunicaciones.',
            '18 de mayo: Día Internacional de los Museos.',
            '23 de mayo: Aniversario de la muerte de Rubén Jaramillo, líder agrarista (1962).',
        ],
    },
    {
        mes: 'Junio',
        eventos: [
            '1 de junio: Día de la Marina.',
            '5 de junio: Día Mundial del Medio Ambiente.',
            '7 de junio: Día de la Libertad de Expresión en México.',
            '10 de junio: Jueves de Corpus o “Halconazo” (1971).',
            '17 de junio: Día Mundial de Lucha contra la Desertificación y la Sequía.',
            '18 de junio: Fundación del Banco de México (1925).',
            '23 de junio: Día Internacional de las Viudas.',
            '24 de junio: Día Internacional contra el Trabajo Infantil.',
            '29 de junio: Día de San Pedro y San Pablo.',
        ],
    },
    {
        mes: 'Julio',
        eventos: [
            '6 de julio: Fallecimiento de Frida Kahlo (1954).',
            '11 de julio: Día Mundial de la Población.',
            '18 de julio: Aniversario luctuoso de Benito Juárez (1872).',
            '19 de julio: Natalicio de Francisco Villa (1878).',
            '30 de julio: Fusilamiento de Miguel Hidalgo y Costilla (1811).',
        ],
    },
];

const renderEventoConFechaEnNegritas = (evento) => {
    const [fecha, ...descripcion] = evento.split(':');

    if (descripcion.length === 0) {
        return evento;
    }

    return (
        <>
            <strong>{fecha}:</strong>
            {descripcion.join(':')}
        </>
    );
};

const Efemerides = () => (
    <div className="efemerides-container container py-4">
        <Helmet>
            <title>Efemérides</title>
            <meta property="og:title" content="Efemérides" />
            <meta property="og:description" content="Lista de efemérides importantes para el ciclo escolar." />
            <meta property="og:image" content="https://primarturogro.edu.mx/uploads/LogoArturo.png" />
            <meta property="og:url" content="https://primarturogro.edu.mx/efemerides" />
            <meta property="og:type" content="website" />
        </Helmet>
        <h1>Efemérides</h1>
        <p>A continuación, se presentan las efemérides sugeridas para el Ciclo Escolar:</p>
        <div className="efemerides-content row row-cols-1 row-cols-md-3 g-4">
            {efemeridesPorMes.map(({ mes, eventos }) => (
                <div className="col" key={mes}>
                    <div className="card h-100 efemerides-card">
                        <div className="card-body">
                            <h2 className="card-title h5">{mes}</h2>
                            <ul className="efemerides-list">
                                {eventos.map((evento) => (
                                    <li key={evento}>{renderEventoConFechaEnNegritas(evento)}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default Efemerides;
